(function (app) {

    var state = {
        options: {},
        payment: {}
    };

    var isCurrentMethodAvailable = function() {
        var hasCurrentMethod = app.models.currentMethod.hasCurrentMethod();
        var canPayByCurrentMethod = app.models.currentMethod.applicableByPaymentOptions();

        return !hasCurrentMethod || canPayByCurrentMethod;
    }

    var paymentChanged = function () {
        var currentMethodAvailable = isCurrentMethodAvailable();

        if (state.options.isOurPaySelect && !currentMethodAvailable && !app.models.currentMethod.get('UseDirectPayment')) {
            app.models.delivery.options.first().select();
        }
    }

    var optionChanged = function () {
        var current = _.clone(app.models.currentMethod.getCurrentMethod());
        var currentMethodAvailable = isCurrentMethodAvailable();
        if (state.options.isOurPaySelect && !currentMethodAvailable) {
            //app.models.currentMethod.clean();
            current = { IsNew: true };
        }
        current.IsOurpaySelect = state.options.isOurPaySelect;
        app.models.currentMethod.set('CurrentMethod', current);
    }

    var changeMethod = function (model) {
        var current = model.get('CurrentMethod');
        if (current.IsNew) {
            state.payment.isMasterPass = false;
            state.payment.isPayPal = false;
            state.payment.isBraintree = false;
            state.payment.isOurpayAvailabled = app.models.ourpay.isEnabled();
        } else {
            state.payment.isMasterPass = current && current.IsMasterPass || false;
            state.payment.isPayPal = current && current.IsPayPal || false;
            state.payment.isBraintree = current && !state.payment.isMasterPass && !state.payment.isPayPal || false;
            state.payment.isOurpayAvailabled = app.models.ourpay.isEnabled() &&
                !app.models.ourpay.isRejectedByInvalidPaymentMethod();
        }
        state.payment.isNew = current.IsNew;
        paymentChanged();
    }
    app.models.currentMethod.on('change:CurrentMethod', function (m) { setTimeout(changeMethod, 0, m); });


    var changeOption = function (model) {
        setTimeout(function () {
            if (model && model.get('Selected')) {
                state.options.isOurPaySelect = model && model.isOurpaySelect() || false;
                optionChanged();
            }
        }, 0);
    }
    app.checkout.orderXhr.done(function () {
        changeOption(app.models.delivery.options.where({ Selected: true })[0]);
        //app.models.delivery.options.on('change:Selected', changeOption);
    });

    app.checkout.onUpdate(function () {
        changeOption(app.models.delivery.options.where({ Selected: true })[0]);
    });

})(app);